import React, { useEffect, useState } from "react";
import styles from "./StickyBottomOverlay.module.scss";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

// OS-5942: Sticky add to bag CTA on mobile PDPs
// targetElementId - pass id of the element to be tracked
// buttons - pass array of button objects with label, classname and ref properties
const StickyBottomOverlay = ({ targetElementId, buttons }) => {
  // State to track the visibility of the overlay
  const [isVisible, setIsVisible] = useState(true);
  // Hook to determine if the viewport is mobile-sized
  const isMobile = useMediaQuery("(max-width: 767px)");

  useEffect(() => {
    // Function to handle scroll events and determine if the target element is fully visible
    const handleScroll = () => {
      const targetElement = document.getElementById(targetElementId);
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        // Set visibility to false if the target element is fully within the viewport
        setIsVisible(!(rect.top >= 0 && rect.bottom <= window.innerHeight));
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);
    return () => {
      // Cleanup scroll event listener on component unmount
      window.removeEventListener("scroll", handleScroll);
    };
  }, [targetElementId]);

  useEffect(() => {
    // Add or remove a CSS class on the body element based on visibility and viewport size
    if (isMobile && isVisible) {
      if (typeof document !== "undefined") {
        document.querySelector("body").classList.add("sticky-bottom-overlay");
      }
    } else {
      if (typeof document !== "undefined") {
        document.querySelector("body").classList.remove("sticky-bottom-overlay");
      }
    }
  }, [isVisible, isMobile]);

  // Do not render the overlay if it is not visible
  if (!isVisible) return null;

  return (
    <>
      {isMobile && (
        // Render the sticky bottom overlay with buttons if on a mobile viewport
        <div className={styles.sticky_bottom_overlay}>
          {buttons.map((button, index) => (
            <button
              key={index}
              className={`btn-primary small-xs small-sm normal-md ${button.className}`}
              // Trigger the click event of the referenced button
              onClick={button?.onClick}
            >
              {button.label}
            </button>
          ))}
        </div>
      )}
    </>
  );
};

export default StickyBottomOverlay;